import { useCallback, useMemo } from 'react';
import { MapMouseEvent } from 'react-map-gl';
import { useSearchParams } from 'react-router-dom';

export const useZipCodesGeoInteraction = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedZipCodes = useMemo(
    () => searchParams.get('zipCodes')?.split(',').filter(Boolean) || [],
    [searchParams]
  );

  const setSelectedZipCodes = useCallback(
    (zipCodes: string[]) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);

        if (zipCodes.length > 0) {
          next.set('zipCodes', zipCodes.join(','));
        } else {
          next.delete('zipCodes');
        }

        return next;
      });
    },
    [setSearchParams]
  );

  const handleMapClick = useCallback(
    (event: MapMouseEvent) => {
      const map = event.target;
      const features = map.queryRenderedFeatures(event.point, {
        layers: ['multi-polygon'],
      });

      if (features.length > 0) {
        const shiftKey = event.originalEvent.shiftKey;
        const selectedZipCode = features[0].properties?.zipCode as string;

        if (shiftKey) {
          const newZipCodes = selectedZipCodes.includes(selectedZipCode)
            ? selectedZipCodes.filter((zipCode) => zipCode !== selectedZipCode)
            : [...selectedZipCodes, selectedZipCode];

          setSelectedZipCodes(newZipCodes);
        } else {
          setSelectedZipCodes([selectedZipCode]);
        }
      } else {
        setSelectedZipCodes([]);
      }
    },
    [selectedZipCodes, setSelectedZipCodes]
  );

  return {
    selectedZipCodes,
    setSelectedZipCodes,
    handleMapClick,
  };
};
